import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/github/workspace/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "commenttypeenum"
    }}>{`CommentTypeEnum`}</h1>
    <p>{`Enum for type of the comment`}</p>
    <h2 {...{
      "id": "class"
    }}>{`Class`}</h2>
    <blockquote>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`STICKY_NOTE_TYPE`}</strong>{` = 1635021678`}</p>
      <p parentName="blockquote">{`Type is sticky note`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`HIGHLIGHT_TEXT_TYPE`}</strong>{` = 1635018860`}</p>
      <p parentName="blockquote">{`Type is highlight text`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`UNDERLINE_TEXT_TYPE`}</strong>{` = 1635022188`}</p>
      <p parentName="blockquote">{`Type is underline text`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`SQUIGGLY_TEXT_TYPE`}</strong>{` = 1635021681`}</p>
      <p parentName="blockquote">{`Type is squiggly text`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`STRIKETHROUGH_TEXT_TYPE`}</strong>{` = 1635021682`}</p>
      <p parentName="blockquote">{`Type is strikethrough text`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`REPLACE_TEXT_TYPE`}</strong>{` = 1635021428`}</p>
      <p parentName="blockquote">{`Type is replace text`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`INSERT_TEXT_TYPE`}</strong>{` = 1635019124`}</p>
      <p parentName="blockquote">{`Type is insert text`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`TEXT_TYPEWRITER_TYPE`}</strong>{` = 1635021940`}</p>
      <p parentName="blockquote">{`Type is text typewriter`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`TEXT_BOX_TYPE`}</strong>{` = 1635021922`}</p>
      <p parentName="blockquote">{`Type is text box`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`FREEFORM_DRAWING_TYPE`}</strong>{` = 1635018340`}</p>
      <p parentName="blockquote">{`Type is freeform drawing`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`LINE_SEGMENT_TYPE`}</strong>{` = 1635019891`}</p>
      <p parentName="blockquote">{`Type is line segment`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`OVAL_TYPE`}</strong>{` = 1635020662`}</p>
      <p parentName="blockquote">{`Type is oval`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`RECTANGLE_TYPE`}</strong>{` = 1635021420`}</p>
      <p parentName="blockquote">{`Type is rectangle`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`POLYGON_TYPE`}</strong>{` = 1635020908`}</p>
      <p parentName="blockquote">{`Type is polygon`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`ARROW_TYPE`}</strong>{` = 1635017074`}</p>
      <p parentName="blockquote">{`Type is arrow`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`TEXT_CALLOUT_TYPE`}</strong>{` = 1635021923`}</p>
      <p parentName="blockquote">{`Type is text callout`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`STAMP_TYPE`}</strong>{` = 1635021680`}</p>
      <p parentName="blockquote">{`Type is stamp`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`CONNECTED_LINES_TYPE`}</strong>{` = 1635017582`}</p>
      <p parentName="blockquote">{`Type is connected lines`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`CLOUD_TYPE`}</strong>{` = 1635017572`}</p>
      <p parentName="blockquote">{`Type is cloud`}</p>
      <hr parentName="blockquote"></hr>
      <p parentName="blockquote"><em parentName="p">{`Read Only`}</em>{` `}</p>
      <p parentName="blockquote">{`Number `}<strong parentName="p">{`INVALID_COMMENT_TYPE`}</strong>{` = 1635019118`}</p>
      <p parentName="blockquote">{`Type is invalid comment type`}</p>
    </blockquote>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      